module.exports = require("@swa-ui/core/src/ToggleButtonGroup/ToggleButtonGroup.module.scss");